// The opponent's strength against the owner's rating.
import { ratingBandOf } from '../classify.ts';
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { RATING_BANDS } from '@chess/api-model';

export const rating: FilterCriterion<'rating'> = {
  key: 'rating',
  query: 'rating',
  many: true,
  parse: oneOf(RATING_BANDS),
  format: (v) => v,
  matches: (game, v) => ratingBandOf(game) === v,
  control: { kind: 'choice', order: 40, more: true, label: 'Opponent', options: [['stronger', 'Stronger'], ['similar', 'Similar'], ['weaker', 'Weaker']] },
};
